import React, { useState } from "react";
import Navbar from "./Navbar";
import "./RegisterPage.css";
import googleLogo from "../assets/google_logo.png"; // Google logo image

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    fullName: "",
    country: "",
    nativeLanguage: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    console.log("Form Submitted", formData);
  };

  const handleGoogleLogin = () => {
    console.log("Google login clicked");
    // integrate Google OAuth here
  };

  return (
    <div className="register-page">
      <Navbar />
      <main className="form-container">
        <h2>Create a New Account</h2>

        {/* Google Login */}
        <button className="google-btn" onClick={handleGoogleLogin}>
          <img src={googleLogo} alt="Google logo" />
          Continue with Google
        </button>

        <p className="or-divider">OR</p>

        <form onSubmit={handleSubmit}>
          <fieldset className="fieldset">
            <legend>Account Details</legend>
            <div className="form-field">
              <label>Username</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
            </div>
          </fieldset>

          <fieldset className="fieldset">
            <legend>Profile Details</legend>
            <div className="form-field">
              <label>Full Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <label>Country</label>
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                required
              >
                <option value="">Select Country</option>
                <option value="India">India</option>
                <option value="USA">USA</option>
                <option value="UK">UK</option>
              </select>
            </div>
            <div className="form-field">
              <label>Native Language</label>
              <select
                name="nativeLanguage"
                value={formData.nativeLanguage}
                onChange={handleChange}
                required
              >
                <option value="">Select Language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Spanish">Spanish</option>
              </select>
            </div>
          </fieldset>

          <button type="submit">Register</button>
        </form>

        <p className="login-link">
          Already have an account? <a href="/login">Login here</a>
        </p>
      </main>
    </div>
  );
};

export default RegisterPage;
